import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageToggle from './LanguageToggle';
import { motion, useReducedMotion } from 'framer-motion';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const reduceMotion = useReducedMotion();
  const locale = i18n.language?.startsWith('ar') ? 'ar-SA' : 'en-US';
  const dateTimeLabel = now.toLocaleString(locale, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <Box
      component={motion.div}
      initial={reduceMotion ? false : { y: -48, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100 }}
    >
    <AppBar
      position="static"
      elevation={0}
      sx={{
        height: 38,
        bgcolor: 'rgba(30, 30, 34, 0.98)',
        color: '#fff',
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.12)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Toolbar
        variant="dense"
        disableGutters
        sx={{
          minHeight: 38,
          height: 38,
          px: { xs: 2, sm: 3 },
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            letterSpacing: 0.5,
            fontSize: { xs: 14, sm: 16 },
            fontFamily: 'Ubuntu, sans-serif',
            justifySelf: 'start',
            whiteSpace: 'nowrap',
          }}
        >
          {t('navbar.name')}
        </Typography>

        <Typography
          component="div"
          sx={{
            justifySelf: 'center',
            opacity: 0.85,
            fontSize: { xs: 12, sm: 14 },
            fontFamily: 'Ubuntu, sans-serif',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          }}
        >
          {dateTimeLabel}
        </Typography>

        <Box sx={{ justifySelf: 'end', direction: 'ltr' }}>
          <LanguageToggle />
        </Box>
      </Toolbar>
    </AppBar>
    </Box>
  );
};

export default Navbar;
